import type {
  TGetSimChatsQueryParams,
  TSimChatDto,
  TSimChatsDto
} from '@homepal/api-contract'

import { getWithRedirect } from 'utils/axios'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/internal/sim-chats`

function buildQuery(params: TGetSimChatsQueryParams) {
  const search = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== '') {
      search.append(key, value)
    }
  })

  const query = search.toString()

  return query ? `?${query}` : ''
}

/** Stored SIM chats of every customer, newest activity first. */
export async function getSimChats(params: TGetSimChatsQueryParams = {}) {
  return getWithRedirect<TSimChatsDto>(`${URL}${buildQuery(params)}`)
}

/** One stored SIM chat with every turn. */
export async function getSimChat(chatId: string) {
  return getWithRedirect<TSimChatDto>(`${URL}/${chatId}`)
}
